__turbopack_context__.v({
  "img": "styles-module__9ZE6eq__img",
});
